(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ap-motor-scene"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ap-motor-scene')) {
  class APMotorScene extends HTMLElement {
   connectedCallback() {
    this.controller?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.frame);
    this.controller=new AbortController(); const signal=this.controller.signal;
    this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
    this.gauges=[...this.querySelectorAll('[data-gauge]')];
    this.visible=false; this.frame=0; this.played=false; this.started=null;
    this.paint=(progress=null,returning=false)=>{
     for(const g of this.gauges) {
      const min=Number(g.dataset.min),max=Number(g.dataset.max),rest=Number(g.dataset.rest);
      const reading=progress===null?rest:returning?max+(rest-max)*progress:min+(max-min)*progress;
      const value=Math.max(min,Math.min(max,reading));
      const angle=-130+(value-min)/(max-min)*260;
      g.querySelector('.ap-motor-needle').setAttribute('transform','rotate('+angle+' 105 102)');
      g.querySelector('.ap-gauge-value').textContent=g.dataset.gauge==='rpm'?String(Math.round(value*1000/50)*50):g.dataset.gauge==='boost'?value.toFixed(1):String(Math.round(value));
     }
    };
    this.tick=(now)=>{
     this.frame=0;
     if(!this.visible||document.hidden||this.reduced.matches)return;
     if(this.gauges.length&&!this.played) {
      this.started??=now;
      const elapsed=Math.min(2400,now-this.started);
      const returning=elapsed>=1200;
      const progress=returning?(elapsed-1200)/1200:Math.min(1,elapsed/900);
      const eased=progress*progress*(3-2*progress);
      this.paint(eased,returning);
      if(elapsed<2400)this.frame=requestAnimationFrame(this.tick);else{this.played=true;this.paint();this.removeAttribute('data-running');}
     } else if(!this.gauges.length) {
      const rect=this.getBoundingClientRect();
      const p=Math.max(0,Math.min(1,(innerHeight-rect.top)/(innerHeight+rect.height)));
      const lift=Math.sin(p*Math.PI);
      this.style.setProperty('--motor-shell',(-12-lift*47)+'px');
      this.style.setProperty('--motor-power',(-lift*8)+'px');
      this.style.setProperty('--motor-wheels',(lift*10)+'px');
      this.removeAttribute('data-running');
     }
    };
    this.queue=()=>{if(!this.frame&&this.visible&&!this.reduced.matches&&!document.hidden&&(!this.gauges.length||!this.played)){this.setAttribute('data-running','');this.frame=requestAnimationFrame(this.tick);}};
    this.sync=()=>{
     if(!this.visible||this.reduced.matches||document.hidden){
      cancelAnimationFrame(this.frame);this.frame=0;this.removeAttribute('data-running');
      if(this.started!==null||this.reduced.matches){this.played=true;this.paint();}
     } else this.queue();
    };
    this.paint(this.reduced.matches?null:0);
    window.addEventListener('scroll',this.queue,{passive:true,signal});
    window.addEventListener('resize',this.queue,{passive:true,signal});
    document.addEventListener('visibilitychange',this.sync,{signal});
    this.reduced.addEventListener('change',this.sync,{signal});
    this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.sync();},{threshold:.15});
    this.observer.observe(this);
   }
   disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();cancelAnimationFrame(this.frame);this.frame=0;}
  }
  customElements.define('ap-motor-scene',APMotorScene);
 }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ap-scene-motion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ap-scene-motion')) {
  class APSceneMotion extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.video = this.querySelector('video');
      this.media = this.parentElement;
      this.image = this.media.querySelector('img');
      this.host = this.closest('.slideshow__slide') || this.closest('.shopify-section');
      if (!this.video || !this.image || !this.host || !this.querySelector('source[data-src]')) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.reduced = matchMedia('(prefers-reduced-motion:reduce)');
      this.connection = navigator.connection;
      this.inView = false;
      this.ready = false;
      this.failed = false;
      this.video.muted = true;
      this.video.controls = false;
      this.host.classList.add('ap-scene-motion__host');
      this.video.addEventListener('error', () => {
        this.failed = true;
        this.sync();
      }, options);
      const update = () => this.sync();
      this.reduced.addEventListener('change', update, options);
      this.connection?.addEventListener('change', update, options);
      document.addEventListener('visibilitychange', update, options);
      window.addEventListener('resize', update, options);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.sync();
      }, { threshold: 0.05 });
      this.observer.observe(this.media);
      const prepare = () => {
        this.timer = window.setTimeout(() => {
          if (!this.isConnected) return;
          this.ready = true;
          this.sync();
        }, 1200);
      };
      if (this.image.complete && this.image.naturalWidth) prepare();
      else this.image.addEventListener('load', prepare, { ...options, once: true });
    }
    restricted() {
      return this.reduced.matches || this.connection?.saveData || ['slow-2g', '2g'].includes(this.connection?.effectiveType);
    }
    shouldPlay() {
      return this.isConnected && this.ready && this.inView && !document.hidden && !this.failed && !this.restricted();
    }
    async sync() {
      if (!this.abort || !this.isConnected) return;
      this.video.style.setProperty('--ap-scene-position', getComputedStyle(this.image).objectPosition);
      if (this.restricted() || this.failed) {
        this.video.pause();
        this.video.classList.remove('ap-scene-motion__visible');
        return;
      }
      if (!this.shouldPlay()) {
        this.video.pause();
        return;
      }
      if (!this.video.hasAttribute('src')) {
        const sources = [...this.querySelectorAll('source[data-src]')].sort((a,b) => Number(a.dataset.width) - Number(b.dataset.width));
        const target = window.innerWidth < 750 ? 1280 : 1920;
        const source = sources.find(item => Number(item.dataset.width) >= target) || sources[sources.length - 1];
        this.video.src = source.dataset.src;
      }
      try {
        await this.video.play();
        if (this.shouldPlay()) {
          this.video.classList.add('ap-scene-motion__visible');
        } else this.video.pause();
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.failed = true;
          this.video.classList.remove('ap-scene-motion__visible');
        }
      }
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.observer?.disconnect();
      clearTimeout(this.timer);
      this.video?.pause();
    }
  }
  customElements.define('ap-scene-motion', APSceneMotion);
}
  } catch(e) { console.error(e); }
})();

})();
